import {Injectable} from '@angular/core';
import {RequesterService} from "../../shared/services/requester/requester.service";
import {Website} from "./website";
import {Product, ProductOrigin} from "./product";
import {BehaviorSubject} from "rxjs";
import {DbResponse} from "../../shared/interceptors/db-response";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../store";
import * as fromStore from '../../store';
import {Config} from "../../config/config";

@Injectable()
export class ProductActionService {

  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;

  constructor(
    private _requester: RequesterService,
    private _store: Store<DbStoreState>
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe( workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });
  }

  public initProductAction(website: Website, products: Product[], action: string, network: number = 0): BehaviorSubject<DbResponse> {
    return this._requester.manager
      .post(`workspaces/${this.currentWorkspaceId}/manager/actions`, null, this.getPostData(website, products, action, network));
  }

  private getPostData(website: Website, products: Product[], action: string, network: number): any {
    const firstProduct: Product = products[0];

    const type: string = firstProduct.type;

    let postData = {
      action: action,
      domain_id: website && website.isNetwork && !website.parentId && website.children && website.children ? website.children[0] : (website.id ? website.id : website),
      upload: firstProduct.origin === ProductOrigin.UPLOAD ? 1 : 0,
      type: type,
      network_wide: network
    };
    if (firstProduct.origin === ProductOrigin.UPLOAD) {
      Object.assign(postData, {
        file: firstProduct.file
      });
    }
    else {
      Object.assign(postData, {
        products: JSON.stringify(products.map((product: Product) => {
          let origin: string = product.origin;
          if (product.availableForHosting && !website.domain_hash && !product.service && !product.hasPaidVersionPremium) {
            product.hasPaidVersion = false;
          }
          if (origin === ProductOrigin.TEN_WEB && !Config.tenWebProducts.includes(product.slug)) {
            const isUpgrading: boolean = product.hasPaidVersion && !product.paidVersionInstalled && ['install', 'install_activate'].includes(action);
            if (!product.paidVersionInstalled && !isUpgrading) {
              origin = ProductOrigin.WORDPRESS;
            }
          }
          const data = {
            id: product.productId || 0,
            type: product.type,
            slug: product.slug || '',
            title: product.title,
            origin: origin,
            service: product.service || '',
            current_version: product.version || '',
            product_state: product.active
          };
          if (product && product.currentVersion) {
            data['version'] = (product.paidVersionInstalled ? product.currentVersion.paid : product.currentVersion && product.currentVersion.free) || '';
          }
          return data;
        }))
      });
    }

    return postData;
  }

}
